// Module
var code = "<div ui-tour=\"welcome\" ui-tour-backdrop=\"true\" ui-tour-template-url=\"'/shared/tour-step-template.html'\" ui-tour-use-hotkeys=\"true\" ui-tour-scroll-parent-id=\"content-main\" post-render=\"setupHomeTour\"> <div class=\"home-page\" compile=\"homeContent\"> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/home.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;